


































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
@Component({
    components: {CTextField, CEditDialog},
})
export default class UserEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        UserName: 'UserName',
        FullName: 'FullName',
    };
}
